module.exports = __webpack_public_path__ + "img/51ABITO-MAYA-U-COLORI-LINO-STAMPE-LINO10.cf66c969.jpg";